import { render, staticRenderFns } from "./empty.vue?vue&type=template&id=11886a76&scoped=true"
import script from "./empty.vue?vue&type=script&lang=js"
export * from "./empty.vue?vue&type=script&lang=js"
import style0 from "./empty.vue?vue&type=style&index=0&id=11886a76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11886a76",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonsChangeLanguageLoading: require('/app/components/Commons/ChangeLanguageLoading.vue').default})
